import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { KpiService } from '@app/services/kpi.service';
import {
  loadPortfolioKpiTrendLines,
  loadPortfolioKpiWorkflowSteps,
  loadPortfolioKpis,
  loadPortfolioKpisFailed,
  loadPortfolioKpisTrend,
  loadPortfolioKpisTrendFailed,
  loadPortfolioKpisWorkflowStepsFailed,
  setPortfolioKpiTrendLines,
  setPortfolioKpiWorkflowSteps,
  setPortfolioKpis,
  setPortfolioKpisTrend,
} from '@dashboards/store/actions/kpi.actions';
import { SnackbarErrorMessage } from '@ui-components/components/customized-snackbar/snackbar-message.enum';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';
@Injectable()
export class KpiEffects {
  loadPortfolioKpi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioKpis),
      switchMap(action =>
        this.kpiService.fetch(action.portfolioId, 0, action.kpiTypes).pipe(
          map(kpis => {
            return setPortfolioKpis({ kpis: kpis || [] });
          }),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.ErrorPortfolioKpi);
            return of(loadPortfolioKpisFailed());
          })
        )
      )
    )
  );

  loadPortfolioKpisTrend$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioKpisTrend),
      switchMap(action =>
        this.kpiService.fetch(action.portfolioId, -action.dateOffset, action.kpiTypes).pipe(
          map(kpis => {
            return setPortfolioKpisTrend({ kpis: kpis || [] });
          }),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.ErrorPortfolioKpi);
            return of(loadPortfolioKpisTrendFailed());
          })
        )
      )
    )
  );

  loadPortfolioKpiTrendLines$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioKpiTrendLines),
      switchMap(action =>
        this.kpiService.trend(action.portfolioId, action.kpiTypes, action.trendDays).pipe(
          map(kpis => {
            return setPortfolioKpiTrendLines({ kpis: kpis || [] });
          }),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.ErrorPortfolioKpi);
            return of(loadPortfolioKpisTrendFailed());
          })
        )
      )
    )
  );

  loadPortfolioKpiWorkflowSteps$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPortfolioKpiWorkflowSteps),
      switchMap(action =>
        this.kpiService.trend(action.portfolioId, action.kpiTypes, action.trendDays).pipe(
          map(kpis => {
            return setPortfolioKpiWorkflowSteps({ kpis: kpis || [] });
          }),
          catchError(() => {
            this.snackbarService.error(SnackbarErrorMessage.ErrorPortfolioKpi);
            return of(loadPortfolioKpisWorkflowStepsFailed());
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<{}>,
    private snackbarService: SnackbarService,
    private kpiService: KpiService
  ) {}
}
